import gql from "graphql-tag";
export const CHECK_PASSWORD_TOKEN = gql`
  query validateUserToken($token: String!) {
    validateUserToken(token: $token)
  }
`;
